<template>
  <v-card flat>
    <v-card-text>
      <v-alert type="info" text v-if="listaSolics.length == 0">
        Nenhuma solicitação localizada
      </v-alert>

      <v-card
        v-for="(solic, i) in listaSolics"
        :key="i"
        class="grey lighten-3 mt-4 rounded-lg"
        v-else
      >
        <v-card-title class="font-weight-bold pb-3">
          <v-row dense>
            <v-col cols="auto">
              <v-icon :class="solic.class_icones.class_cor_web">{{
                solic.class_icones.icone_web
              }}</v-icon>
            </v-col>
            <v-col>
              {{ solic.tipo_solicitacao }}
            </v-col>
            <v-col class="d-flex justify-end" v-if="!isMobile()">
              <btn-cancelar-solic
                v-if="solic.pode_cancelar"
                :solicitacao="solic"
              />
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-subtitle class="green--text font-weight-bold subtitle-1 pb-2">
          {{ solic.desc_plano }}
        </v-card-subtitle>
        <v-card-subtitle class="pt-0 pb-2">
          {{ textoSolicitacao(solic) }}
        </v-card-subtitle>
        <v-card-subtitle class="pt-0">
          <v-chip small outlined :style="estiloStatus(solic)">{{
            solic.desc_status
          }}</v-chip>
        </v-card-subtitle>
        <v-card-subtitle class="pt-0 pb-1">
          <v-row
            dense
            v-if="solic.observacao.trim().length > 2 || solic.corrigir_docs"
          >
            <v-col v-if="solic.corrigir_docs">
              <v-alert type="warning" text>
                <template v-if="solic.observacao.trim().length > 2">
                  <p class="caption font-weight-bold mb-2">Observação</p>
                  <span class="subtitle-1">{{ solic.observacao }}</span>
                </template>

                <btn-corrigir-docs
                  :solicitacao="solic"
                  v-if="solic.corrigir_docs"
                />
              </v-alert>
            </v-col>
            <v-col v-if="solic.coletar_assinatura">
              <v-alert type="info" text>{{ solic.observacao }}</v-alert>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <template v-if="solic.exibir_valores">
          <v-divider></v-divider>
          <v-card-title class="font-weight-bold subtitle-2"
            >Valores totais do plano</v-card-title
          >
          <v-card-subtitle>
            <v-row dense>
              <v-col xl="2" lg="2" md="2" cols="12">
                <p>Valor do plano</p>
                <p class="font-weight-bold subtitle-1">
                  {{ formatarMoeda(solic.vlr_tot_plano) }}
                </p>
              </v-col>
              <v-col xl="2" lg="2" md="2" cols="12">
                <p>A Coasul paga</p>
                <p class="font-weight-bold blue--text subtitle-1">
                  {{ formatarMoeda(solic.vlr_tot_pago_coasul) }}
                </p>
              </v-col>
              <v-col xl="2" lg="2" md="2" cols="12">
                <p>Você paga</p>
                <p class="font-weight-bold green--text subtitle-1">
                  {{ formatarMoeda(solic.vlr_tot_pago_func) }}
                </p>
              </v-col>
            </v-row>
          </v-card-subtitle>
        </template>
        <template v-if="solic.dependentes.length > 0">
          <v-divider></v-divider>
          <v-card-title class="font-weight-bold subtitle-2 pb-1"
            >Dependentes selecionados</v-card-title
          >
          <v-card-text>
            <v-list class="grey lighten-3 pt-0">
              <v-list-item
                v-for="(dep, i) in solic.dependentes"
                :key="i"
                class="rounded grey lighten-5 pt-2 mt-2"
              >
                <v-list-item-content>
                  <v-list-item-title class="subtitle-1">{{
                    dep.nome
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <p class="warning--text mb-2">{{ dep.parentesco }}</p>
                    <template v-if="dep.exibir_valores">
                      <v-row dense>
                        <v-col align-self="center" class="pb-0">
                          Valor do plano
                        </v-col>
                        <v-col
                          align-self="center"
                          class="d-flex justify-end subtitle-1 pb-0"
                        >
                          {{ formatarMoeda(dep.vlr_plano) }}
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col align-self="center" class="pb-0 pt-0">
                          A Coasul pagará
                        </v-col>
                        <v-col
                          align-self="center"
                          class="
                            d-flex
                            justify-end
                            subtitle-1
                            font-weight-bold
                            blue--text
                            pb-0
                            pt-0
                          "
                        >
                          {{ formatarMoeda(dep.vlr_pago_coasul) }}
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col align-self="center" class="pt-0">
                          O colaborador pagará
                        </v-col>
                        <v-col
                          align-self="center"
                          class="
                            d-flex
                            justify-end
                            subtitle-1
                            font-weight-bold
                            green--text
                            pt-0
                          "
                        >
                          {{ formatarMoeda(dep.vlr_pago_func) }}
                        </v-col>
                      </v-row>
                    </template>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </template>
        <v-card-actions v-if="isMobile()">
          <btn-cancelar-solic v-if="solic.pode_cancelar" :solicitacao="solic" />
        </v-card-actions>
      </v-card>
    </v-card-text>
  </v-card>
</template>
<script>
import { dateFormat, formatMoeda } from "@/global";
import BtnCancelarSolic from "../buttons/BtnCancelarSolic.vue";
import BtnCorrigirDocs from "../buttons/BtnCorrigirDocs.vue";
export default {
  components: { BtnCancelarSolic, BtnCorrigirDocs },
  props: {
    listaSolics: Array,
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    textoSolicitacao(solic) {
      return `Solicitado em ${dateFormat(solic.data_solic)}  às ${
        solic.hora_solic
      }`;
    },
    estiloStatus(solic) {
      return {
        color: `rgb(${solic.cores[0]},${solic.cores[1]},${solic.cores[2]})`,
        "background-color": "white !important",
        "border-color": `rgb(${solic.cores[0]},${solic.cores[1]},${solic.cores[2]})`,
      };
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

<style>
</style>